import { render } from "./EstimateDetailBefore.vue?vue&type=template&id=22843c52"
import script from "./EstimateDetailBefore.vue?vue&type=script&lang=js"
export * from "./EstimateDetailBefore.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__